module.exports = __webpack_public_path__ + "static/img/title@2x.fa675ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/MYBANK/title@2x.png
// module id = Brhw
// module chunks = 69